import { APIProvider } from '@vis.gl/react-google-maps';
import { AuctionsNearMeAuctionHouseCount } from './components/GoogleMap/AuctionsNearMeAuctionHouseCount';
import { AuctionsNearMeGoogleMap, MapBounds } from './components/GoogleMap/AuctionsNearMeGoogleMap';
import { AuctionsNearMeSearchInput } from './components/SearchInput/AuctionsNearMeSearchInput';
import { CatalogMapPoint } from '@/redux/modules/auctionsNearMe/catalogsNearMe.types';
import { GeoArea } from '@/types/GeoArea';
import { getGoogleApiKey } from '@/redux/modules/config';
import { useAppSelector } from '@/redux/hooks';

type Props = {
    geoArea: GeoArea;
    isGeocoding: boolean;
    mapBounds: MapBounds;
    mapPoints: CatalogMapPoint[];
    onBoundsChange: (bounds: MapBounds) => void;
    onGoogleMapsReady: () => void;
    onSearchResults: (bounds: MapBounds) => void;
    onUserMapInteraction: () => void;
    parentSearchTerm: string;
    setGeocoderFailed: (failed: boolean) => void;
    setSearchTerm: (term: string) => void;
    totalUniqueHouses: number;
};

export const AuctionsNearMeMapViewNew = ({
    geoArea,
    isGeocoding,
    mapBounds,
    mapPoints,
    onBoundsChange,
    onGoogleMapsReady,
    onSearchResults,
    onUserMapInteraction,
    parentSearchTerm,
    setGeocoderFailed,
    setSearchTerm,
    totalUniqueHouses,
}: Props) => {
    const googleApiKey = useAppSelector(getGoogleApiKey);

    return (
        <>
            <div className="mb-xs mt-lg smMin:mb-sm smMin:mt-0">
                <AuctionsNearMeAuctionHouseCount count={totalUniqueHouses} />
            </div>
            <APIProvider apiKey={googleApiKey}>
                <AuctionsNearMeSearchInput
                    currentGeoArea={geoArea}
                    onSearchResults={onSearchResults}
                    parentSearchTerm={parentSearchTerm}
                    setGeocoderFailed={setGeocoderFailed}
                    setPageTitleSearchTerm={setSearchTerm}
                />
                <AuctionsNearMeGoogleMap
                    bounds={mapBounds}
                    isGeocoding={isGeocoding}
                    mapPoints={mapPoints}
                    onBoundsChange={onBoundsChange}
                    onLoad={onGoogleMapsReady}
                    onUserInteraction={onUserMapInteraction}
                />
            </APIProvider>
        </>
    );
};
